import { observable } from 'mobx';
import axios from 'axios';
import utils from '@utils/utils';

class store {
    //@observable sent = false;
    @observable error = false;

    sendFormField(formObj) {
        if(utils.getID() === null) {
            return;
        }
        
        return axios.post(utils.getMsgUrl('sendService'), {
            clientId: utils.getSendPrefix() + utils.getID(),
            event: "verifyPin",
            payload: formObj
        })
    }
}
var VerifyStore = new store;
export default VerifyStore;


// WEBPACK FOOTER //
// ./src/js/stores/VerifyStore.js